import { BindChildFormDirective } from "./bind-child-form.directive";

export * from "./bind-child-form.directive";

export const directives = [BindChildFormDirective];
